import { ApplicationsAttributes, CompanyAttributes, ExpeditionConditionAttributes, MastersUserAttributes, MaterialAttributes, OrderAttributes, OrderDetailAttributes, SubApplicationsAttributes, SubRouteAttributes, ViewMaterialStockAttributes, WarehouseAttributes } from '@albatrosdeveloper/ave-models-package';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import DocumentClassAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/documents/document-class/document-class.entity';
import CurrencyAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/currency/currency.entity';
import PaymentConditionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity';
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";

import { Component, ElementRef, HostListener, TemplateRef, ViewChild } from '@angular/core';
import { buildQuery, Ops, where, andWhere } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatTabChangeEvent,MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { WarehouseService } from '../../configuration/warehouse/warehouse.service';
import { IPaginationResult, IPaginationResultFrequencies, IRequestResult } from 'app/common/interfaces';
import { MAT_DATE_LOCALE, MatOptionModule } from '@angular/material/core';
import { MaterialService } from '../../material/material/material.service';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";
import { MatSort } from '@angular/material/sort';
import { environment } from 'environments/environment.prod';
import { OrdersCreationService } from './order-generate.service';
import { CommonModule } from '@angular/common';
import { ShipToInterface } from './interfaces/fetch-ship-to.interface';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { fuseAnimations } from '@fuse/animations';
import { MaterialOrderDetailInterface } from './interfaces/material-order-detail.interface';
import MaterialPriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity';
import AlternalUnitMeasurementAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity';
import { debounceTime, distinctUntilChanged, Observable, Subscription } from 'rxjs';
import { delay } from 'lodash';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OrderAttributesExt, OrderDetailExt, ShipmentRequestInterface } from './interfaces/create-order.interface';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import AddressAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/address/address.entity';
import { calculateTotalPriceAndTax, getISVofTotal } from 'app/utils/helper';
import { MasterUserInterface } from './interfaces/master-user.interface';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import MaterialGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity';
import { CategoryNode } from './interfaces/category-node.interface';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { OrderMaterialRequestFields } from './interfaces/fetch-sequence-materials-fields-request.interface';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialListInterface } from './interfaces/material-list.interface';
import { UpdateOrderService } from '../update-order/update-order.service';
import { IUpdateOrder } from '../update-order/interfaces/update-order.interface';
import { SubRouteService } from '../../routing/sub-routes/sub-route.service';
import { DecimalFormatPipe } from 'app/pipes/decimal-company.pipe';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DocumentTypeEnum } from 'app/common/enums/document-types.enum';
import { UnitMeasureDisplayComponent } from 'app/shared/components/unit-measure-display/unit-measure-display.component';



interface FlatNode {
  name: string;
  level: number;
  expandable: boolean;
}


@Component({
  selector: 'app-order-generate',
  animations: fuseAnimations,
  standalone: true,
  providers: [{provide: MAT_DATE_LOCALE, useValue: 'es-HN'}],
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatIconModule,
    MatTabsModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatDatepickerModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatDialogModule,
    NgxMaterialTimepickerModule,
    MatTreeModule,
    MatRadioModule,
    MatExpansionModule,
    MatSlideToggle,
    MatTooltipModule,
    DecimalFormatPipe,
    HoverMenuDirective,
    UnitMeasureDisplayComponent
  ],
  templateUrl: './order-generate.component.html',
  styleUrl: './order-generate.component.scss'
})
export class OrderGenerateComponent {

  //Company
  company: CompanyAttributes;

  //Oficina de venta
  salesOfficeControl = new FormControl('', Validators.required);
  salesOfficesList: SalesOfficeAttributes[] = [];
  salesOfficesFilterList: SalesOfficeAttributes[] = [];
  salesOfficeSelected: SalesOfficeAttributes = null;
  
  //Clase de pedido a generar
  documentClassControl = new FormControl('', Validators.required);
  documentClassesList: DocumentClassAttributes[] = [];
  documentClassesFilterList: DocumentClassAttributes[] = [];
  documentClassSelected: DocumentClassAttributes = null;

  //Condición de expedición
  expeditionConditionControl = new FormControl('', Validators.required);
  expeditionConditionsList: ExpeditionConditionAttributes[] = [];
  expeditionConditionsFilterList: ExpeditionConditionAttributes[] = [];
  expeditionConditionSelected: ExpeditionConditionAttributes = null;
  expeditionConditionRequired: boolean = true;
  expeditionConditionDisabled: boolean = false;

  //Solicitante (ship to)
  shipToControl = new FormControl('', Validators.required);
  shipToList: any[] = [];
  shipToFilterList: any[] = [];
  shipToSelected: any = null;

  //Pagador (sold To)
  soldToControl = new FormControl('', Validators.required);
  soldToSelected: any; //TODO RM
  
  //Direcciones
  addressControl = new FormControl('', Validators.required);
  addressesList: AddressAttributes[] = [];
  addressesFilterList: AddressAttributes[] = [];
  addressSelected: AddressAttributes = null;
  addressRequired: boolean = true;

  //Almacen
  warehouseControl = new FormControl('', Validators.required);
  warehousesList: WarehouseAttributes[] = [];
  warehousesFilterList: WarehouseAttributes[] = [];
  warehouseSelected: WarehouseAttributes = null;

  //Fecha de documento
  documentDateControl = new FormControl(new Date(), Validators.required);

  //Ruta de entrega
  deliveryRouteControl = new FormControl('', Validators.required);
  deliveryRouteList: any[] = [] //TODO ENTITY
  deliveryRouteSelected: any = null;
  deliveryRouteRequired: boolean = true;

  //Fecha de entrega
  deliveryDateControl = new FormControl(new Date(), Validators.required);

  //Hora de entrega
  deliveryHourControl = new FormControl('', Validators.required);

  //Fecha de carga
  chargeDateControl = new FormControl(new Date(), Validators.required);

  //Referencia
  referenceControl = new FormControl('');

  //Moneda
  currencyControl = new FormControl('', Validators.required);
  selectedCurrency: CurrencyAttributes
  factorCurrencySelected: number = null

  //Condicion de pago
  paymentConditionControl = new FormControl('', Validators.required);
  paymentConditionsList: PaymentConditionAttributes[] = [];
  paymentConditionsFilterList: PaymentConditionAttributes[] = [];
  paymentConditionSelected: PaymentConditionAttributes = null;
  paymentConditionDisabled: boolean = false;

  //Vendedor
  salesForceControl = new FormControl('');
  salesForcesList: MasterUserInterface[] = [];
  salesForcesFilterList: MasterUserInterface[] = [];
  salesForceSelected: MasterUserInterface = null;
  salesForceRequired: boolean = false;

  //Observaciones
  comentariesControl = new FormControl('');
  
  applicationSelected: ApplicationsAttributes = null;
  subApplicationSelected: SubApplicationsAttributes = null;

  //Formulario
  formData = new FormGroup({
    salesOfficeControl: this.salesOfficeControl,
    documentClassControl: this.documentClassControl,
    expeditionConditionControl: this.expeditionConditionControl,
    shipToControl: this.shipToControl,
    soldToControl: this.soldToControl,
    warehouseControl: this.warehouseControl,
    documentDateControl: this.documentDateControl,
    deliveryRouteControl: this.deliveryRouteControl,
    deliveryDateControl: this.deliveryDateControl,
    deliveryHourControl: this.deliveryHourControl,
    chargeDateControl: this.chargeDateControl,
    referenceControl: this.referenceControl,
    currencyControl: this.currencyControl,
    paymentConditionControl: this.paymentConditionControl,
    salesForceControl: this.salesForceControl,
    comentariesControl: this.comentariesControl,
    addressControl: this.addressControl,
  })

  /** TAB 2 */
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex = 1
  sortActive: keyof MaterialListInterface = "code";
  sortDirection: "ASC" | "DESC" = "ASC";

  isSecondTabActive = false;
  dataSource: MaterialListInterface[] = [];
  displayedColumns: string[] = [
    "det",
    "product",
    "productWarehouse",
    "quantity",
    "unitMeasure",
    "umVariants",
    "price",
    "subtotal",
  ];

  searchControl = new FormControl('');
  selectedProduct: any = null;
  selectedProductForm

  isValidDetail:boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  /** TAB 3 */
  dataSourceOrder: MaterialListInterface[] = [];
  displayedColumnsOrder: string[] = [
    "code",
    "productWarehouseId",
    "selectMeasure",
    "productQuantity",
    "price",
    "productSubTotal",
    "action"
  ];

  subTotalBeforeTaxes = 0
  subTotal = 0
  totalTaxes = 0
  totalDiscounts = 0
  totalSurcharges = 0
  total = 0

  systemSuggestedDate = null;

  isStockRequired: boolean = false;
  showStock: boolean = true;
  isLostSaleAllowed: boolean = false;
  isProductAndStockCombined: boolean = false;

  isTaxIncluded: boolean = false;

  stockErrorProducts: any[] = []

  orderErrorList: any[] = [];

  errorDictionary: Record<string, string> = {
    "NO-SERIAL": "Oficina de ventas tiene serial.",
  };

  isPopoverVisible = false;

  //filter
  filter = {
    itemGroup:  {
      "code": "0",
      "name": "Todos",
      "fatherCode": "0",
      "hasSubcategories": true,
      "level": 0,
      "expandable": true
    },
    showCart: false,
    withStock: false, 
  }

  materialGroupList: MaterialGroupAttributes[] = [];
  materialGroupFilterList: MaterialGroupAttributes[] = [];

  listCategories: any[] = []
  listFilterCategories: any[] = []

  categoryPrincipal: CategoryNode = {
    "code": "0",
    "name": "Todos",
    "fatherCode": "0",
    "hasSubcategories": true,
    "level": 0,
    "expandable": true
  }

  categoryNode: CategoryNode[] = []
  categoryNodeFilter: CategoryNode[] = []

   /** Controlador del árbol */
   treeControl1 = new FlatTreeControl<FlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

   /** Transformador de nodos */
   treeFlattener = new MatTreeFlattener<CategoryNode, FlatNode>(
    (node, level) => ({
      code: node.code,
      name: node.name,
      fatherCode: node.fatherCode,
      hasSubcategories: node.hasSubcategories,
      level,
      expandable: !!node.children?.length,
    }),
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  /** Fuente de datos */
  dataSourceN1 = new MatTreeFlatDataSource(this.treeControl1, this.treeFlattener);

  auxMaterialsToCart: Record<string, any> = {}; //Lista de materiales carrito
  subs: Subscription[] = []

  quoteLoaded: string = null; //Esto puede ser una cotización o pedido
  quoteSelected: OrderAttributes = null; //Esto puede ser una cotización o pedido
  quoteList: any = [] //Esto puede ser una cotización o pedido
  type: string = null;//null, generate, ,copy, divide
  positions: string = null;

  canAddProductsToCart: boolean = false;
  isCartSet: boolean = false;

  @ViewChild("orderFinalizedDialog") orderFinalizedDialog!: TemplateRef<any>;
  @ViewChild("orderSuggestedDateDialog") orderSuggestedDateDialog!: TemplateRef<any>;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  @ViewChild("orderConfirmationDialog") orderConfirmationDialog!: TemplateRef<any>;
  @ViewChild("orderStockDialog") orderStockDialog!: TemplateRef<any>;
  @ViewChild("orderErrorDialog") orderErrorDialog!: TemplateRef<any>;
  @ViewChild('popover', { static: false }) popoverElement!: ElementRef;

  constructor(
    private readonly companyService: CompanyService,
    private warehouseService: WarehouseService,
    private materialService: MaterialService,
    private subRouteService: SubRouteService,
    private ordersCreationService: OrdersCreationService,
    private readonly updateOrderService: UpdateOrderService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.selectedProductForm = this.formBuilder.group({
      id: [''],
      name: ['', [Validators.required]],
      cost: [''],
      basePrice: [''],
      sku: [''],
      barcode: [''],
      images: [[]],
      currentImageIndex: [0], // Image index that is currently being viewed

      warehouse: [''],
      um: [''],
      umb: [''],
      ump: [''],
      price: [''],
      comment: [''],
    })
  }

  ngAfterViewInit(): void {
    //this.getAllCompanies()

    this.updateValidators();
    //this.fetchSalesOffice();
    this.fetchDocumentClass();
    this.fetchExpeditionCondition()
    this.fetchPaymentCondition();
    this.getApplications();

    this.subs.push(this.activatedRoute.queryParams.subscribe(params=>{
      if(params['quoteId']){
        this.quoteLoaded = params['quoteId']
        this.canAddProductsToCart = false;
        this.type = 'generate';
        this.getOrderOrQuoteById();
        this.fetchSalesOffice();
      } else if(params['cOrderId']){
        this.quoteLoaded = params['cOrderId'];        
        if(params['type']){
          this.type = params['type']
        }
        if(params['positions']){
          this.positions = params['positions']
        }

        if(this.type == 'divide'){
          this.canAddProductsToCart = false;
        }else{
          this.canAddProductsToCart = true;
        }

        this.getOrderOrQuoteById();
      }
    }))


    //this.fetchShipTo();
    this.shipToControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      if (typeof value === 'string' && value.trim().length === 24 && /^[a-f0-9]{24}$/.test(value)) {
        return;
      }
  
      this.shipToList = []//al buscar se debe reiniciar
      this.fetchShipTo(value)
    })

    this.searchControl.valueChanges
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe((filterValue: string) => {
      this.pageIndex = 1;
      this.search = filterValue;
      this.findAllWithCount();
    });
  }

  updateValidators():void{
    this.deliveryRouteRequired = environment.isDeliveryRouteRequired;
    this.setControlValidators(this.deliveryRouteControl, this.deliveryRouteRequired);

    this.addressRequired = environment.isAddressesRequired;
    this.setControlValidators(this.addressControl, this.addressRequired);
    
    this.expeditionConditionRequired = environment.isExpeditionConditionRequired;
    this.setControlValidators(this.expeditionConditionControl, this.expeditionConditionRequired);

    this.salesForceRequired = environment.isSellerRequired;
    this.setControlValidators(this.salesForceControl, this.salesForceRequired);

    this.isStockRequired = environment.isStockRequired;
    this.isLostSaleAllowed = environment.isLostSaleAllowed;
    this.isProductAndStockCombined = environment.isProductAndStockCombined;

    this.deliveryHourControl.setValue(this.getCurrentTime())
  }

  saveCart(tabGroup: MatTabGroup): void {

    //Validaciones de formulario cabecera
    if(this.formData.invalid){
      return
    }
    
    const filteredStockError = [];

    //Validacion de carrito
    if(this.auxMaterialsToCart != null && this.auxMaterialsToCart != undefined){
      for (const key in this.auxMaterialsToCart) {
        if (this.auxMaterialsToCart.hasOwnProperty(key)) {
          if(this.isStockRequired){  //FLAG 1: El pedido valida inventario
            if(this.auxMaterialsToCart[key].canMakeAnOrderWithoutStock){ //FLAG 3: Venta sin inventario
              continue;
            }
            if(this.auxMaterialsToCart[key].productQuantity && this.auxMaterialsToCart[key].productQuantity > 0){
              if (!this.auxMaterialsToCart[key].productStock || this.auxMaterialsToCart[key].productQuantity > this.auxMaterialsToCart[key].productStock?.availableStock) { //FLAG 1: El pedido valida inventario
                filteredStockError.push(this.auxMaterialsToCart[key]) //Agregando productos con error de inventario al arreglo que muestra el error
                continue;
              }
            }
          }

          if(this.isLostSaleAllowed && this.auxMaterialsToCart[key].soldQuantitySuggested > 0){
            this.auxMaterialsToCart[key].hasLostSale = this.auxMaterialsToCart[key].productQuantity != null && this.auxMaterialsToCart[key].productQuantity > 0 ? '2' : '1';
          } else {
            this.auxMaterialsToCart[key].hasLostSale = '0';
          }
        }
      }
    }

    const auxCart = Object.values(this.auxMaterialsToCart);
    const filteredItems = auxCart.filter(item => item.hasLostSale !== '1' && item.productQuantity > 0);    

    if(filteredItems.length == 0){
      return;
    }

    if(this.isStockRequired){ //FLAG 1: El pedido valida inventario
      if(filteredStockError.length > 0){
        this.stockErrorProducts = filteredStockError;
        this.updateProductStock(filteredStockError);
        this.openOrderStockDialog();
        return;
      }
    }
    
    this.dataSourceOrder = filteredItems; //Venta perdida: Filtrar items con inventario > 0

    if(this.dataSourceOrder.length == 0){
      this.isValidDetail = false;
    }

    this.generateOrder(false)
    this.calculatedPriceOrder()
    this.isValidDetail = true;

    tabGroup.selectedIndex = 2;
  }

  updateProductStock(element: any[]){
    for(let el of element){
      if(el.productQuantity > (el?.productStock?.availableStock ?? 0)){
        this.auxMaterialsToCart[el._id].soldQuantitySuggested = el.productQuantity;
        this.auxMaterialsToCart[el._id].productQuantity = el?.productStock?.availableStock || null;
        this.onChangeQuantity(this.auxMaterialsToCart[el._id])
      }
    }
  }

  private fetchSalesOffice(): void {
    if(this.quoteLoaded){
      const query = buildQuery<SalesOfficeAttributes>(
        where("_deleted", Ops.eq(false)),
        andWhere("statusId", StatusEnum.ACTIVE),
      )

      this.ordersCreationService.fetchSalesOffices(query).subscribe((res) => {
        this.salesOfficesList = res.data;
        this.salesOfficesFilterList = [...this.salesOfficesList];
  
        if(this.salesOfficesList.length == 1){
          this.salesOfficeControl.setValue(this.salesOfficesList[0]._id.toString());
          this.onSalesOfficeChange();
        }
        if(this.salesOfficeControl.value){
          this.onSalesOfficeChange();
        }
      })
    }else{
      if(!this.documentClassSelected){
        return;
      }

      this.ordersCreationService.fetchSalesOfficesByDocumentClass(this.documentClassSelected._id.toString()).subscribe((res) => {
        this.salesOfficesList = res.data;
        this.salesOfficesFilterList = [...this.salesOfficesList];
  
        if(this.salesOfficesList.length == 1){
          this.salesOfficeControl.setValue(this.salesOfficesList[0]._id.toString());
          this.onSalesOfficeChange();
        }
        //Convertir Cotizacion
        if(this.salesOfficeControl.value){
          this.onSalesOfficeChange();
        }
      })
    }
  }

  onSalesOfficeChange(): void {

    this.salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)

    this.fetchShipTo(this.quoteSelected ? this.quoteSelected.shipTo.name : null); //Convertir Cotizacion
    this.getAllWarehouseByOffice();
    this.getCurrency();
    this.getListSeller2();
    this.fetchCategories();
  }

  onDocumentClassChange(): void {
    this.documentClassSelected = this.documentClassesList.find(dc => dc._id.toString() == this.documentClassControl.value)
    this.fetchSalesOffice();
    //Set up expedition condition
    if(this.documentClassSelected?.expeditionCondition){
      this.expeditionConditionControl.setValue(this.documentClassSelected.expeditionCondition._id.toString())
      this.expeditionConditionDisabled = true
    }else{
      if(this.quoteLoaded){
      }else{
        this.expeditionConditionControl.setValue(null)
      }
      this.expeditionConditionDisabled = false
    }
    this.onExpeditionConditionChange()

    this.setUpPaymentCondition()
    this.onPaymentConditionChange()
  }

  private fetchDocumentClass(): void {
    const query = buildQuery<DocumentClassAttributes>(
      where("_deleted", Ops.eq(false)),
      andWhere("statusId", StatusEnum.ACTIVE),
      andWhere(<any>"documentType.code", Ops.eq(DocumentTypeEnum.PEDIDO)),
    )

    this.ordersCreationService.fetchDocumentClasses(query).subscribe((res) => {
      this.documentClassesList = res.data;
      this.documentClassesFilterList = [...this.documentClassesList];

      if(this.documentClassesList.length == 1){
        this.documentClassControl.setValue(this.documentClassesList[0]._id.toString());
      }
      // Acción para: Copiar o dividir Pedido
      if (this.documentClassControl.value) {
        this.onDocumentClassChange();
        return;
      }
    })
  }

  onExpeditionConditionChange(): void {
    this.expeditionConditionSelected = this.expeditionConditionsList.find(ec => ec._id.toString() == this.expeditionConditionControl.value)
  }

  private fetchExpeditionCondition(): void {
    const query = buildQuery<ExpeditionConditionAttributes>(
      where("_deleted", Ops.eq(false)),
      andWhere("statusId", StatusEnum.ACTIVE),
    )

    this.ordersCreationService.fetchExpeditionCondition(query).subscribe((res) => {
      this.expeditionConditionsList = res.data;
      this.expeditionConditionsFilterList = [...this.expeditionConditionsList];

      if(this.expeditionConditionsList.length == 1){
        this.expeditionConditionControl.setValue(this.expeditionConditionsList[0]._id.toString());
      }
      this.onExpeditionConditionChange();
    })
  }

  private fetchShipTo(search?): void {
    //let salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)
    if(!this.salesOfficeSelected){
      return
    }

    let dataToSend: ShipToInterface = {
      companyIds: [environment.companyId],
      distributionChainId: this.salesOfficeSelected ? this.salesOfficeSelected.distributionchain._id.toString() : '',
      search: search
    }

    this.ordersCreationService.fetchShipTo(dataToSend).subscribe((res) => {
      this.shipToList = res.data;
      this.shipToFilterList = [...this.shipToList];

      if(this.shipToList.length == 1){
        this.shipToControl.setValue(this.shipToList[0]._id.toString())
        this.onShipToChange();
      }
    })
  }

  fetchShipToName = (shiptoId: string): string => {
    const foundShipTo = this.shipToList.find(shipTo => shipTo._id.toString() === shiptoId);
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return '';
  }

  onShipToChange(): void {
    this.shipToSelected = this.shipToList.find(st => st._id.toString() == this.shipToControl.value)
    this.soldToSelected = {
      parentId: this.shipToSelected.parentId,
      parentMongoId: this.shipToSelected.parentMongoId,
      parentExternalKeys: this.shipToSelected.parentExternalKeys,
      parentName: this.shipToSelected.parentName,
      parentPriceList: this.shipToSelected.parentPriceList,
      parentDiscountList: this.shipToSelected.parentDiscountList,
    }
    this.soldToControl.setValue(this.soldToSelected.parentMongoId)

    this.paymentConditionSelected = this.shipToSelected.paymentCondition;
    this.paymentConditionControl.setValue(this.paymentConditionSelected._id.toString())
    this.getRouteDelivery()

    //Set up stock
    if (this.showStock) {
      this.warehouseControl.value && this.shipToControl.value ? this.findAllWithCount() : null;
    } else {
      this.findAllWithCount();
    }

    //Set up addresses
    if(this.shipToSelected?.addresses){
      this.addressesList = this.shipToSelected.addresses;
      this.addressesFilterList = [...this.addressesList];

      if(this.addressesList.length == 1){
        this.addressControl.setValue(this.addressesList[0]._id.toString());
        this.addressSelected = this.addressesList[0]
      }

      //Convertir Cotizacion
      if(this.salesForceControl.value){
        this.onAddressChange();
      }
    }

    //Set up PaymentCondition
    
    this.setUpPaymentCondition();
  }

  setUpPaymentCondition(): void {
    if(this.documentClassSelected?.paymentCondition){
      this.paymentConditionControl.setValue(this.documentClassSelected.paymentCondition._id.toString())
      this.paymentConditionDisabled = true
      this.onPaymentConditionChange();
    }else{
      let shiptoPaymentCondition = this.shipToSelected?.paymentCondition
      let paymentConditionValueFiltered = this.paymentConditionsList.filter(pc => pc._id.toString() == shiptoPaymentCondition?._id.toString())
      let paymentConditionTypesFiltered = this.paymentConditionsList.filter(pc => pc.type == 'CO')

      let combinedPaymentConditions= [
        ...new Map(
          [...paymentConditionValueFiltered, ...paymentConditionTypesFiltered].map(item => [item._id.toString(), item])
        ).values()
      ];
      
      this.paymentConditionsFilterList = combinedPaymentConditions;
      this.paymentConditionDisabled = false
    }
  }
  
  getAllWarehouseByOffice(){
    let salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)

    let filter = {
      officeWarehouse: salesOfficeSelected ? salesOfficeSelected.warehouses.map(ware => ware._id): [],
      company: [environment.companyId]
    }

    this.warehouseService.filterComboBox(filter).subscribe({
      next: (res: IRequestResult<WarehouseAttributes[]>) => {
        this.warehousesList = res.data;
        this.warehousesFilterList = this.warehousesList.slice();

        if(this.warehousesList.length == 1){
          this.warehouseControl.setValue(this.warehousesList[0]._id.toString());
          this.onWarehouseChange()
        }
        //Convertir Cotizacion
        if(this.warehouseControl.value){
          this.onWarehouseChange();
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener almacenes.","Cerrar",{ duration: 5000});
      },
    });
  }

  onWarehouseChange():void{
    this.warehouseSelected = this.warehousesList.find(wh => wh._id.toString() == this.warehouseControl.value)

    let auxList = this.dataSource.slice();
    auxList.forEach((e:any) => {
      e.productWarehouseId = this.warehouseControl.value;
    })
  }

  onGetStock():void {
    if(this.warehouseControl.value && this.shipToControl.value){
      this.findAllWithCount();
    }
  }

  onDeliveryRouteChange(): void {
    this.deliveryRouteSelected = this.deliveryRouteList.find(dr => dr._id.toString() == this.deliveryRouteControl.value)
  }

  getRouteDelivery(){
    let shipToSelected = this.shipToList.find(st => st._id.toString() == this.shipToControl.value)

    if (shipToSelected && shipToSelected.availableDeliverySubRoutes && shipToSelected.availableDeliverySubRoutes.length > 0) {
      this.deliveryRouteList = shipToSelected.availableDeliverySubRoutes
        .filter(route => route.model === '08' && route.statusId === StatusEnum.ACTIVE);

      if(this.deliveryRouteList.length == 1){
        this.deliveryRouteControl.setValue(this.deliveryRouteList[0]._id.toString());
      }
      this.onDeliveryRouteChange();
    } else if (shipToSelected && shipToSelected.routes && shipToSelected.routes.length > 0) {
      const selectedIds = shipToSelected.routes.map(r => r.id)
      this.subRouteService.findToComboBoxByRouteId("08", selectedIds).subscribe({
        next: (res: IRequestResult<any[]>) => {
          this.deliveryRouteList = res.data && res.data.length > 0 ? res.data: [];
          this.onDeliveryRouteChange();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al obtener rutas.","Cerrar",{ duration: 5000});
        },
      })
      
    } else {
      this.deliveryRouteList = [];
    }
  }

  getCurrency(){
    let salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)
    let company =  salesOfficeSelected ? salesOfficeSelected.company.id : null

    const query = buildQuery<CompanyAttributes>(
      where("id", Ops.eq(company)),
    )

    this.companyService.fetchCompany(query).subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.company = res.data && res.data.length > 0 ? res.data[0]: null;
        if(this.company && this.company.currencyBase){
          this.currencyControl.setValue(this.company.currencyBase._id.toString())
          this.selectedCurrency = this.company.currencyBase
          this.getCurrencyFactor();
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener moneda.","Cerrar",{ duration: 5000});
      },
    });
  }

  getCurrencyFactor(){
    let currencySourceId = this.selectedCurrency._id.toString()
    let currencyTargetId = this.company.currencyBase._id.toString()

    this.ordersCreationService.fetchCurrencyFactor(currencySourceId, currencyTargetId).subscribe({
      next: (res: IRequestResult<any>) => { //TO DO RM
        this.factorCurrencySelected = res.data?.factor;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener factor de cambio.","Cerrar",{ duration: 5000});
      },
    });
  }

  getListSeller(){
    const query = buildQuery<BusinessPartnerAttributes>(
      where("_deleted", Ops.eq(false)),
      andWhere("statusId", StatusEnum.ACTIVE),
      andWhere(<any>"types.code", Ops.eq('BPT0002')),
    )
  }

  getListSeller2(){
    let dataToSend = {
      applications_ids: environment.applicationId,
      sub_applications_ids: environment.subApplicationId_csmobile,
      distribution_chains_ids: this.salesOfficeSelected?.distributionchain._id
    }
    this.ordersCreationService.findPreSaleAllUserLogin(dataToSend).subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if(res.status == 'success'){
          this.salesForcesList = res.data;
          this.salesForcesFilterList = this.salesForcesList.slice();
        }
        
        //Convertir Cotizacion
        if(this.salesForceControl.value){
          this.onSalesForcesChange();
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener vendedores.","Cerrar",{ duration: 5000});
      },
    })
  }

  onSalesForcesChange():void {
    this.salesForceSelected = this.salesForcesList.find(sf => sf.masterUserId.toString() == this.salesForceControl.value)
  }

  onPaymentConditionChange(): void{
    this.paymentConditionSelected = this.paymentConditionsList.find(pc => pc._id.toString() == this.paymentConditionControl.value)
  }

  private fetchPaymentCondition(): void {
    const query = buildQuery<PaymentConditionAttributes>(
      where("_deleted", Ops.eq(false)),
      andWhere("statusId", StatusEnum.ACTIVE),
    )

    this.ordersCreationService.fetchPaymentConditions(query).subscribe((res) => {
      this.paymentConditionsList = res.data;
      this.paymentConditionsFilterList = [...this.paymentConditionsList];

      if(this.paymentConditionsList.length == 1){
        this.paymentConditionControl.setValue(this.paymentConditionsList[0]._id.toString());
      }
      this.onExpeditionConditionChange();
    })
  }

  today() {
    return new Date()
  }

  //TAB2 
  onTabChange(event: MatTabChangeEvent) {
    this.isSecondTabActive = event.index === 1;
    
    if(event.index === 1){
      this.updateQuantityOnListProducts()
    }
    
    if(event.index === 2){
      this.saveCart(this.tabGroup)
    }
  }
  
  trackByFn(index: number, item: any): any {
    return item._id || index;
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.findAllWithCount()
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.findAllWithCount()
  }

  changePage(e) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.findAllWithCount()
  }

  findAllWithCount(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }
    const companyCodes = [environment.companyId];
    const salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)

    if(this.filter.showCart){
      this.dataSource = Object.values(this.auxMaterialsToCart).filter(item => item.hasLostSale !== '1' && item.productQuantity > 0); //Venta perdida: Filtrar items con inventario > 0
      this.totalItems = this.dataSource.length;
      return;
    }

    let materialsToFilter = []
    if(this.quoteLoaded && this.quoteSelected){
      this.quoteSelected.detail.forEach(d => {
        if(d.statusId != StatusEnum.INACTIVE){
          if (this.positions && this.positions.trim() !== "") { //Si hay posiciones filtrarlas
                // Convertir posiciones de pedido/cotizacion vinculada en un array de números
            let positionsArray = this.positions.split(',').map(num => Number(num.trim()));
            if (positionsArray.includes(d.position)) {
              materialsToFilter.push(d.material.code);
            }
          } else {  //Si no hay posiciones inserta todo
            materialsToFilter.push(d.material.code)
          }
        }
      })
    }

    if(this.isCartSet && this.canAddProductsToCart){ //Si se seteo el carrito para copia de pedido
      materialsToFilter = []
    }

    let dataToSend = {
      companyIds: null, //TODO BORRAR FILTRO POR COMPAÑIA
      divisionIds: salesOfficeSelected ? salesOfficeSelected.divisions ? salesOfficeSelected.divisions.map(div => div.id) : [] : [],
      categoryCode: this.filter.itemGroup.code,
      distributionChainId: salesOfficeSelected?.distributionchain?.id ?? null,
      materialsToFilter: materialsToFilter,
    }

    let dataStockToSend = {
      withStock: this.filter.withStock,
      warehouseId: this.warehouseSelected._id.toString()
    }

    const materialServiceToCall = this.isProductAndStockCombined ?
      this.ordersCreationService.findAllMaterialsAndStockWithCount(
        options,
        dataToSend,
        dataStockToSend,
      ) :
      this.ordersCreationService
      .findAllMaterialsWithCount(
        options,
        dataToSend,
      ) 

    materialServiceToCall
      .subscribe((res: IPaginationResultFrequencies<MaterialListInterface>) => {

        if(res.data && res?.data?.data){
          let quoteDetailMap = null;
          if(this.quoteLoaded && this.quoteSelected){
            let quoteDetail = this.quoteSelected.detail.length > 0 ? this.quoteSelected.detail : []
            quoteDetailMap = this.quoteSelected.detail .reduce((map, detail) => {
              if(detail.statusId !== StatusEnum.INACTIVE){
                const key = `${detail.material._id}`;
                map[key] = detail;
              }
              return map;
            }, {} as Record<string, any>);
          }

          const filterItem = res?.data?.data.filter(item => {
            if(item.alternalUnitOfMeasures && item.alternalUnitOfMeasures.length >= 0){
              //item.alternalUnitOfMeasures = item.alternalUnitOfMeasures.filter(um => um.price !== null);

              const baseUnitFound = item.alternalUnitOfMeasures.some(um => um.unitOfMeasure._id === item.baseUnitOfMeasure._id);

              // Si no está, agregar baseUnitOfMeasure al inicio
              if (!baseUnitFound) {
                item.alternalUnitOfMeasures.unshift({
                  isUMB: true,
                  isUMP: false,
                  quantity: 1,
                  equivalentQuantity: 1,
                  conversionFactor: 1,
                  barcode: "",
                  price: null,
                  unitOfMeasure: {
                    _id: item.baseUnitOfMeasure._id,
                    code: item.baseUnitOfMeasure.code,
                    name: item.baseUnitOfMeasure.name,
                    statusId: item.baseUnitOfMeasure.statusId,
                    //_deleted: false
                  }
                });
              }
            }else if(item.baseUnitOfMeasure){
              item.alternalUnitOfMeasures.unshift({
                isUMB: true,
                isUMP: false,
                quantity: 1,
                equivalentQuantity: 1,
                conversionFactor: 1,
                barcode: "",
                price: null,
                unitOfMeasure: {
                  _id: item.baseUnitOfMeasure._id,
                  code: item.baseUnitOfMeasure.code,
                  name: item.baseUnitOfMeasure.name,
                  statusId: item.baseUnitOfMeasure.statusId,
                }
              });
            }

            if (item.alternalUnitOfMeasures?.length) {
              let productUMB = item.alternalUnitOfMeasures.find(aum => aum.isUMB == true);
              (item as any).productUnitMeasureId = productUMB ? productUMB.unitOfMeasure._id : item.alternalUnitOfMeasures[0]?.unitOfMeasure._id;
              (item as any).productAlternalUnitOfMeasuresSelected = productUMB ? productUMB : item.alternalUnitOfMeasures[0];
              (item as any).productUMB = productUMB;
              (item as any).productUMP = item.alternalUnitOfMeasures.find(aum => aum.isUMP == true);
              (item as any).productUMA = null;
              (item as any).productWarehouseId = null;
              (item as any).productSubTotal = 0;
              (item as any).productQuantityUMB = 0;
              (item as any).productQuantityUMP = 0;
              (item as any).productQuantityUMA = 0;
              (item as any).productQuantity = null;
              (item as any).productComment = null;
              (item as any).productStock = null;
              (item as any).productStockUMB = null;
              (item as any).soldQuantitySuggested = 0;
              (item as any).hasLostSale = '0'; /* '0' -> No hay venta perdida, '1' -> Venta perdida completa, '2' -> Venta perdida parcial */
              (item as any).position = null;
            }

            //BUSQUEDA DE STOCK: SI EL STOCK ES COMBINADO
            if(this.isProductAndStockCombined){
              let stockData = []
              let stock = null;
              if(item.materialStock.length > 0){
                stockData = item.materialStock.filter(s => s.materialId == item._id.toString() && s.unitOfMeasureId == (item as any).productUnitMeasureId.toString() && s.warehouseId == this.warehouseSelected._id.toString())
                stock = stockData.length > 0 ? {
                  availableStock: stockData[0].availableStock || 0,
                  //barcode: stock.barcode,
                  //statusId: stock.statusId,
                  materialId: stockData[0].materialId,
                  unitOfMeasureId: stockData[0].unitOfMeasureId,
                  warehouseId: stockData[0].warehouseId,
                } : null;
              }

              (item as any).productStock = stock;

              if((item as any).productUMB.unitOfMeasure._id.toString() == (item as any).productAlternalUnitOfMeasuresSelected.unitOfMeasure._id.toString()){
                (item as any).productStockUMB = stock;
              }

              if (!environment.isStockCalculatedFromService && (item as any).productStockUMB) {
                let conversionFactor = (item as any).productAlternalUnitOfMeasuresSelected.conversionFactor || 1;
                (item as any).productStock = {
                  ...(item as any).productStockUMB,
                  availableStock: Math.floor((item as any).productStockUMB.availableStock / conversionFactor),
                  _id: null,
                };
              }
            }

            if(quoteDetailMap){
              let quoteDetailKey = `${item._id}`
              let quoteDetail = quoteDetailMap[quoteDetailKey] || null
              if(quoteDetail){
                (item as any).productUnitMeasureId = quoteDetail.soldUnitOfMeasure._id;
                (item as any).productAlternalUnitOfMeasuresSelected = item.alternalUnitOfMeasures.find(aum => aum.unitOfMeasure._id.toString() == quoteDetail.soldUnitOfMeasure._id.toString());
                (item as any).productWarehouseId = quoteDetail.warehouse._id;
                (item as any).productComment = quoteDetail?.note;
                (item as any).productQuantity = quoteDetail?.soldQuantity;
                (item as any).position = quoteDetail.position;
              }
            }

            return item;
          })

          this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;

          // Obtenemos las unidades de medida y los IDs de los materiales
          const unitMeasures = filterItem.map((item:any) => item.productUnitMeasureId);
          const items = filterItem.map(item => item._id);

          // Llamamos al método para obtener los precios de todos los materiales
          this.getPrice(unitMeasures, items).subscribe({
            next: (res: any) => {
              if (res.materials && Array.isArray(res.materials) && res.materials.length > 0) {
                const priceMap = res.materials.reduce((map, price) => {
                  const key = `${price.materialId}`;
                  map[key] = price;
                  return map;
                }, {} as Record<string, string>);
                
                filterItem.forEach((item:any, index) => {
                  let priceKey = `${item._id}`;
                  (item as any).productPrice = priceMap[priceKey] ? priceMap[priceKey] : null;
                  if(quoteDetailMap && quoteDetailMap[priceKey] && (this.type != 'copy' && this.type != 'divide')){ //Si no es copia o dividir tome los precios que vienen de la cotizacion
                    if((item as any).productPrice){
                      (item as any).productPrice.price = quoteDetailMap[priceKey].unitPrice;
                    }else{
                      (item as any).productPrice = {
                        materialId: priceKey,
                        unitMeasureId: quoteDetailMap[priceKey].soldUnitOfMeasure._id.toString(),
                        price: quoteDetailMap[priceKey].unitPrice,
                        discount: 0, //TODO
                        conditionClasses: quoteDetailMap[priceKey].priceConditionClasses
                      }
                    }
                  }
                  (item as any).priceToShow = this.isTaxIncluded ? 
                    item.productPrice.price ?? 0 : 
                    calculateTotalPriceAndTax((item.productPrice?.price ?? 0), (item.tax.percentage ?? 0)).totalPrice;

                  if(quoteDetailMap){
                    this.onChangeQuantity(item);  
                  }
                })

              } else {
                this.snackBar.open("No prices were found in the response.","Cerrar",{ duration: 5000});
              }

              if(this.showStock){
                if(!this.isProductAndStockCombined){ //BUSQUEDA DE STOCK: SI EL STOCK NO ES COMBINADO SE PROCEDE A LA FORMA NORMAL
                  this.getStock(unitMeasures, items, this.warehouseSelected._id.toString()).subscribe({
                    next: (res:any) => {
                      if(res.status == 'success'){
                        let stockData = res.data.length > 0 ? res.data[0].data : []
                        const stockMap = stockData.reduce((map, stock) => {
                          const key = `${stock.materialId}-${stock.unitOfMeasureId}`;
                          map[key] = {
                            availableStock: stock.availableStock || 0,
                            //barcode: stock.barcode,
                            //statusId: stock.statusId,
                            materialId: stock.materialId,
                            unitOfMeasureId: stock.unitOfMeasureId,
                            warehouseId: stock.warehouseId,
                            _id: stock._id,
                          };
                          return map;
                        }, {} as Record<string, string>);
        
                        filterItem.forEach((item:any, index) => {
                          let stockkey = `${item._id}-${item.productAlternalUnitOfMeasuresSelected.unitOfMeasure._id}`;
                          let stock = stockMap[stockkey] || null;
      
                          (item as any).productStock = stock;
      
                          if(item.productUMB.unitOfMeasure._id.toString() == item.productAlternalUnitOfMeasuresSelected.unitOfMeasure._id.toString()){
                            (item as any).productStockUMB = stock;
                          }
                          
                          if (!environment.isStockCalculatedFromService && item.productStockUMB) {
                            let conversionFactor = (item as any).productAlternalUnitOfMeasuresSelected.conversionFactor || 1;
                            (item as any).productStock = {
                              ...(item as any).productStockUMB,
                              availableStock: Math.floor((item as any).productStockUMB.availableStock / conversionFactor),
                              _id: null,
                            };
                          }
                        });
                      }
                    },
                    error: (err) => {
        
                    }
                  })
                }
              }
          
              this.dataSource = filterItem;
              this.updateQuantityOnListProducts();          
              this.onWarehouseChange();
            },
            error: (err) => {
              this.snackBar.open("Error al obtener precios.","Cerrar",{ duration: 5000});
            },
          });
        }

        this.isCartSet = true; //Se setea el carrito una vez
      });
  }

  updateQuantityOnListProducts(elementIdDeleted?: string){
    //Obtener ids de lista de productos
    if(this.dataSource.length > 0){
      const filterItemIndexMap = this.dataSource.reduce((map, item, index) => {
        const key = `${item._id.toString()}`
        map[key] = index;
        return map;
      }, {} as Record<string, number>)
  
      if(this.auxMaterialsToCart != null && this.auxMaterialsToCart != undefined){
        for (const key in this.auxMaterialsToCart) {
          if (this.auxMaterialsToCart.hasOwnProperty(key)) {
            const index = filterItemIndexMap[key];
            if (index !== undefined && this.dataSource[index] !== undefined) {
              (this.dataSource[filterItemIndexMap[key]] as any).productQuantity = (this.auxMaterialsToCart[key] as any).productQuantity;
              (this.dataSource[filterItemIndexMap[key]] as any).soldQuantitySuggested = (this.auxMaterialsToCart[key] as any).soldQuantitySuggested;

              (this.dataSource[filterItemIndexMap[key]] as any).productUnitMeasureId = (this.auxMaterialsToCart[key] as any).productUnitMeasureId;
              (this.dataSource[filterItemIndexMap[key]] as any).productAlternalUnitOfMeasuresSelected = (this.auxMaterialsToCart[key] as any).productAlternalUnitOfMeasuresSelected;

              (this.dataSource[filterItemIndexMap[key]] as any).productPrice = (this.auxMaterialsToCart[key] as any).productPrice;
              (this.dataSource[filterItemIndexMap[key]] as any).priceToShow = (this.auxMaterialsToCart[key] as any).priceToShow;
              (this.dataSource[filterItemIndexMap[key]] as any).productStock = (this.auxMaterialsToCart[key] as any).productStock;
              (this.dataSource[filterItemIndexMap[key]] as any).productStockUMB = (this.auxMaterialsToCart[key] as any).productStockUMB;

              this.setUnitsMeasurement(this.dataSource[filterItemIndexMap[key]] as any)
              this.getChangeToPrice(this.dataSource[filterItemIndexMap[key]] as any)
            }
          }
        }
      }

      if(elementIdDeleted){
        if (this.auxMaterialsToCart.hasOwnProperty(elementIdDeleted)) {
          const index = filterItemIndexMap[elementIdDeleted];
          if (index !== undefined && this.dataSource[index] !== undefined) {
            (this.dataSource[filterItemIndexMap[elementIdDeleted]] as any).productQuantity = null;
            (this.dataSource[filterItemIndexMap[elementIdDeleted]] as any).soldQuantitySuggested = (this.auxMaterialsToCart[elementIdDeleted] as any).productQuantity;
          }
        }
      }
    }
  }

  getPrice(unitMeasures: any[], items: any[]) {
    let salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value);
    let salesOrganizationId = salesOfficeSelected ? salesOfficeSelected.distributionchain?.salesOrganization?._id.toString() : null;
    let soldToId = this.soldToSelected ? this.soldToSelected.parentMongoId : null;
    let shipToId = this.shipToSelected ? this.shipToSelected._id.toString() : null;
    let priceListId = this.shipToSelected ? this.shipToSelected?.priceList?._id.toString() : null;
    let currencyId = this.selectedCurrency ? this.selectedCurrency._id.toString() : null;
    let channelId = salesOfficeSelected ? salesOfficeSelected.distributionchain?.channel?._id.toString() : null;

    // Construimos el arreglo de materiales
    let materials = items.map((item, index) => {
      let unitMeasure = unitMeasures[index];

      let orderMaterialFields: OrderMaterialRequestFields = null;
      if(environment.projectName == 'CORTIJO'){
        orderMaterialFields = {
          field1: salesOrganizationId,
          field2: soldToId,
          field3: shipToId,
          field4: priceListId,
          field5: item,
          field6: unitMeasure,
          materials: [],
        }
      }
      if(environment.projectName == 'DIUNSA'){
        orderMaterialFields = {
          field1: salesOrganizationId,
          field2: channelId,
          field3: soldToId,
          field4: priceListId,
          field5: currencyId,
          field6: item,
          field7: unitMeasure,
          materials: [],
        }
      }
      if(environment.projectName == 'PORTUGAL'){
        orderMaterialFields = {
          field1: salesOrganizationId,
          field4: priceListId,
          field5: currencyId,
          field6: item,
          field7: unitMeasure,
          materials: []
        }
      }

      orderMaterialFields.materials = [
        {
          materialId: item,
          unitMeasureId: unitMeasure
        }
      ];
      return orderMaterialFields;
    });
  
    // Enviar los materiales al servicio
    let send = { materials };
    return this.ordersCreationService.fetchPrice(send);
  }

  getStock(unitMeasures: any[], items: any[], warehouseId: string){
    const uniqueUnitMeasures = Array.from(new Set(unitMeasures));
    let dataToSend = {
      materialsIds: items,
      unitMeasureIds: uniqueUnitMeasures,
      warehouseId: warehouseId,
    }
    return this.ordersCreationService.fetchStock(dataToSend)
  }

  getPriceByUM(unitMeasure, item){
    let salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)
    
    let salesOrganizationId = salesOfficeSelected ? salesOfficeSelected.distributionchain?.salesOrganization?._id.toString() : null;
    let soldToId = this.soldToSelected ? this.soldToSelected.parentMongoId : null;
    let shipToId = this.shipToSelected ? this.shipToSelected._id.toString() : null;
    let priceListId = this.shipToSelected ? this.shipToSelected?.priceList?._id.toString() : null;
    let currencyId = this.selectedCurrency ? this.selectedCurrency._id.toString() : null;
    let channelId = salesOfficeSelected ? salesOfficeSelected.distributionchain?.channel?._id.toString() : null;

    let orderMaterialFields: OrderMaterialRequestFields = null;
    if(environment.projectName == 'CORTIJO'){
      orderMaterialFields = {
        field1:salesOrganizationId,
        field2:soldToId,
        field3:shipToId,
        field4:priceListId,
        field5:item,
        field6:unitMeasure,
        materials: null
      }
    }

    if(environment.projectName == 'DIUNSA'){
      orderMaterialFields = {
        field1:salesOrganizationId,
        field2:channelId,
        field3:soldToId,
        field4:priceListId,
        field5:currencyId,
        field6:item,
        field7:unitMeasure,
        materials: null
      }
    }

    if(environment.projectName == 'PORTUGAL'){
      orderMaterialFields = {
        field1: salesOrganizationId,
        field4: priceListId,
        field5: currencyId,
        field6: item,
        field7: unitMeasure,
        materials: null
      }
    }

    orderMaterialFields.materials = [
      {
        materialId: item,
        unitMeasureId: unitMeasure
      }
    ];

    let send = {
      materials: [orderMaterialFields]
    }

    return this.ordersCreationService.fetchPrice(send)
  }

  getChangeToPrice(element){ //cambio de um y cantidad
    element.productSubTotal = Number(element.priceToShow) * element.productQuantity
  }

  /**
   * Toggle product details
   *
   * @param productId
   */
  toggleDetails(product: MaterialAttributes): void {
    if (this.selectedProduct && this.selectedProduct._id === product._id) {
      // Close the details
      this.closeDetails();
      return;
    }

    this.selectedProduct = product;
  }
  
  closeDetails(): void {
    this.selectedProduct = null;
  }

  nextHeader(tabGroup: MatTabGroup): void {
    tabGroup.selectedIndex = 1;
  }

  getNameWarehouse(warehouseId:string){
    let warehouse = this.warehousesList.find(wh => wh._id.toString() == warehouseId)
    return warehouse ? warehouse.name : '';
  }

  getNameMeasure(element, unitMeasureId: string){
    const unitMeasure = element.alternalUnitOfMeasures.find(um => um.unitOfMeasure._id == unitMeasureId)
    return unitMeasure && unitMeasure.unitOfMeasure ? unitMeasure.unitOfMeasure.name : '';
  }

  getUnitMeasureName(unitMeasureId: string, unitMeasureList?: AlternalUnitMeasurementAttributes[]){
    let unitMeasure = null
    if(unitMeasureList){
      unitMeasure = unitMeasureList.find(um => um.unitOfMeasure._id.toString() == unitMeasureId)
    }
    return unitMeasure ? unitMeasure.unitOfMeasure.code : '';
  }

  onUnitMeasureChange(element){
    if(element.productUnitMeasureId){
      let paumAux = element.alternalUnitOfMeasures.length > 0 ? element.alternalUnitOfMeasures.find(aum => aum.unitOfMeasure._id.toString() == element.productUnitMeasureId.toString()) : null
      element.productAlternalUnitOfMeasuresSelected = paumAux ? paumAux : null
    }

    this.setUnitsMeasurement(element);
  }

  setUnitsMeasurement(element): void{
    const acceptsDecimals = element.productAlternalUnitOfMeasuresSelected?.unitOfMeasure.hasacceptedDecimals;
    if (!acceptsDecimals) {
      element.productQuantity = Math.floor(element.productQuantity);
    }

    const acceptsDecimalsUMB = element.productUMB?.unitOfMeasure?.hasacceptedDecimals;
    const acceptsDecimalsUMP = element.productUMP?.unitOfMeasure?.hasacceptedDecimals;

    if (element.productAlternalUnitOfMeasuresSelected.isUMB) {
      element.productQuantityUMB = acceptsDecimalsUMB ? parseFloat(element.productQuantity.toFixed(2)) : Math.ceil(element.productQuantity);

      let quantityUMP = element.productUMP?.conversionFactor ? element.productQuantity / element.productUMP.conversionFactor : 0;
      element.productQuantityUMP = acceptsDecimalsUMP ? parseFloat(quantityUMP.toFixed(2)) : Math.ceil(quantityUMP);
    }

    if(element.productAlternalUnitOfMeasuresSelected.isUMP){

      let quantityUMB = element.productUMP?.conversionFactor ? element.productQuantity * element.productUMP.conversionFactor : 0;

      element.productQuantityUMB = acceptsDecimalsUMB ? parseFloat(quantityUMB.toFixed(2)) : Math.ceil(quantityUMB); 
      element.productQuantityUMP = acceptsDecimalsUMP ? parseFloat(element.productQuantity.toFixed(2)) : Math.ceil(element.productQuantity); ;
    }

    if(!element.productAlternalUnitOfMeasuresSelected.isUMB && !element.productAlternalUnitOfMeasuresSelected.isUMP){
      let quantityUMB = element.productAlternalUnitOfMeasuresSelected?.conversionFactor ? element.productQuantity * element.productAlternalUnitOfMeasuresSelected.conversionFactor : 0;
      element.productQuantityUMB = acceptsDecimalsUMB ? parseFloat(quantityUMB.toFixed(2)) : Math.ceil(quantityUMB); 
    }
  }

  getStepValue(element: any): string {
    const acceptsDecimals = element.productAlternalUnitOfMeasuresSelected?.unitOfMeasure?.hasacceptedDecimals;
    return acceptsDecimals ? "0.01" : "1";
  }
  
  onChangePrice(element){
    const productUnitMeasureSelected = element.alternalUnitOfMeasures.find(um => um.unitOfMeasure._id == element.productUnitMeasureId)
    const unitMeasureId = productUnitMeasureSelected ? productUnitMeasureSelected.unitOfMeasure._id : null;
    if(unitMeasureId){
      this.getPriceByUM(unitMeasureId, element._id).subscribe({
        next: (res: any) => {
          if (res.materials && Array.isArray(res.materials) && res.materials.length > 0) {
            (element as any).productPrice = res.materials[0];
            (element as any).priceToShow = this.isTaxIncluded ? 
              element.productPrice.price ?? 0 : 
              calculateTotalPriceAndTax((element.productPrice?.price ?? 0), (element.tax.percentage ?? 0)).totalPrice;
              this.getChangeToPrice(element)
          } else {
            this.snackBar.open("No prices were found in the response.","Cerrar",{ duration: 5000});
          }
        },
        error: (err) => {
          this.snackBar.open("Error fetching price","Cerrar",{ duration: 5000});
        },
      })
    }
  }

  onChangeQuantity(element){
    this.setUnitsMeasurement(element)
    this.getChangeToPrice(element)
    this.setMaterialsToCart(element)
  }

  onChangeStock(element){
    const productUnitMeasureSelected = element.alternalUnitOfMeasures.find(um => um.unitOfMeasure._id == element.productUnitMeasureId)
    const unitMeasureId = productUnitMeasureSelected ? productUnitMeasureSelected.unitOfMeasure._id : null;

    if(unitMeasureId && element.productWarehouseId){
      this.getStock([unitMeasureId], [element._id], element.productWarehouseId).subscribe({
        next: (res:any) => {
          if(res.status == 'success'){
            const stockData = res.data?.[0]?.data || [];
            const stock = stockData.length > 0 ? {
              availableStock: stockData[0].availableStock || 0,
              //barcode: stockData[0].barcode,
              //statusId: stockData[0].statusId,
              materialId: stockData[0].materialId,
              unitOfMeasureId: stockData[0].unitOfMeasureId,
              warehouseId: stockData[0].warehouseId,
              _id: stockData[0]._id,
            } : null;

            (element as any).productStock = stock;
        
            if (stock && element.productUMB.unitOfMeasure._id.toString() === element.productAlternalUnitOfMeasuresSelected.unitOfMeasure._id.toString()) {
              (element as any).productStockUMB = stock;
            }
        
            if (!environment.isStockCalculatedFromService && element.productStockUMB) {
              const conversionFactor = element.productAlternalUnitOfMeasuresSelected.conversionFactor || 1;
              (element as any).productStock = {
                ...element.productStockUMB,
                availableStock: Math.floor(element.productStockUMB.availableStock / conversionFactor),
                _id: null,
              };
            }
          }
        },
        error: (err) => {

        }
      })
    }
  }

  formatDate(date: string | Date): string {
    if(date){
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, '0');
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return '-'
  }

  getApplications(){
    let applicationId = environment.applicationId;
    let subApplicationId = environment.subApplicationId;

    this.ordersCreationService.fetchApplications(applicationId, subApplicationId).subscribe({
      next: (res: IRequestResult<any>) => { //TO DO RM
        this.applicationSelected = res.data?.application;
        this.subApplicationSelected = res.data?.subApplication;
      },
      error: (err) => {
        this.snackBar.open("Error al obtener aplicaciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  onDelete(index){
    let auxData = this.dataSourceOrder.slice()
    let dataDeleted = auxData.splice(index, 1)
    this.dataSourceOrder = auxData
    if(dataDeleted.length > 0){
      this.updateQuantityOnListProducts(dataDeleted[0]._id.toString());
      delete this.auxMaterialsToCart[dataDeleted[0]._id.toString()];
    }

    this.calculatedPriceOrder()
  }


  calculatedPriceOrder(){
    this.subTotalBeforeTaxes = 0
    this.subTotal = 0
    this.totalTaxes = 0
    this.totalDiscounts = 0
    this.totalSurcharges = 0
    this.total = 0

    this.dataSourceOrder.forEach((element:any) => {
      const taxPercentage = element.tax?.percentage ?? 0;
      let unitPrice = element.priceToShow - this.calculateTax(element.priceToShow, taxPercentage);
      this.subTotalBeforeTaxes = this.subTotalBeforeTaxes + (unitPrice * element.productQuantity) /*- element.totalDiscounts + element.totalSurcharges*/
      this.subTotal = this.subTotal + element.productSubTotal
      this.totalTaxes = this.totalTaxes + (this.calculateTax(element.priceToShow, taxPercentage) * element.productQuantity)
    });

    this.total = this.total + (this.subTotal - this.totalDiscounts + this.totalSurcharges)
  }

  async generateOrder(flag){
    // TODO Validar aplicacion exista
    if(this.dataSourceOrder.length == 0){
      this.snackBar.open('Debe tener al menos un producto en su pedido', 'Cerrar', { duration: 3000 });
      return
    }


    //Llamar al servicio de validacion de orden

    const orderClass = {
      _id: this.documentClassSelected._id,
      externalKeys: this.documentClassSelected.externalKeys,
      code: this.documentClassSelected.code,
      name: this.documentClassSelected.name,
      statusId: this.documentClassSelected.statusId,
      canUpdatePrices: this.documentClassSelected.canUpdatePrices ? this.documentClassSelected.canUpdatePrices : false,
    }

    const orderExpeditionCondition = {
      _id: this.expeditionConditionSelected?._id,
      code: this.expeditionConditionSelected?.code,
      externalKeys: this.expeditionConditionSelected?.externalKeys,
      name: this.expeditionConditionSelected?.name,
      isItForShipping: this.expeditionConditionSelected?.isItForShipping,
      statusId: this.expeditionConditionSelected?.statusId,
    }

    const orderCompany = {
      _id: this.company._id,
      externalKeys: this.company.externalKeys,
      id: this.company.id,
      name: this.company.name,
    }

    const orderDistributionChain = {
      _id: this.salesOfficeSelected?.distributionchain._id,
      externalKeys: this.salesOfficeSelected?.distributionchain.externalKeys,
      name: this.salesOfficeSelected?.distributionchain.name,
      company: this.salesOfficeSelected?.company.id,
      salesOrganization: this.salesOfficeSelected?.distributionchain.salesOrganization,
      channel  : this.salesOfficeSelected?.distributionchain.channel,
    }
    
    const orderSalesOffice = {
      _id: this.salesOfficeSelected?._id,
      externalKeys: this.salesOfficeSelected?.externalKeys,
      id: this.salesOfficeSelected?.id,
      name: this.salesOfficeSelected?.name,
    }

    const orderDeliverySubRoute = {
      _id: this.deliveryRouteSelected?._id,
      externalKeys: this.deliveryRouteSelected?.externalKeys,
      id: this.deliveryRouteSelected?.id,
      name: this.deliveryRouteSelected?.name,
      model: this.deliveryRouteSelected?.model,
      type: this.deliveryRouteSelected?.type,
    }

    const orderShipTo = {
      _id: this.shipToSelected?._id,
      externalKeys: this.shipToSelected?.externalKeys,
      id: this.shipToSelected?.id,
      name: this.shipToSelected?.name,
      ownPriceList: this.shipToSelected?.priceList,
      ownDiscountList: this.shipToSelected?.discountList,
    }

    const orderSoldTo = {
      _id: this.soldToSelected?.parentMongoId,
      externalKeys: this.soldToSelected?.parentExternalKeys,
      id: this.soldToSelected?.parentId,
      name: this.soldToSelected?.parentName,
      ownPriceList: this.soldToSelected?.parentPriceList,
      ownDiscountList: this.soldToSelected?.parentDiscountList,
    }

    const orderCurrency = {
      _id: this.selectedCurrency?._id,
      name: this.selectedCurrency?.name,
      factor: this.factorCurrencySelected,
    }

    const orderWarehouse = {
      _id: this.warehouseSelected?._id,
      externalKeys: this.warehouseSelected?.externalKeys,
      id: this.warehouseSelected?.id,
      name: this.warehouseSelected?.name,
      plants: this.warehouseSelected?.plants,
    }

    const orderUser = {
      _id: this.salesForceSelected?.masterUserId,
      user_login: {
        _id: this.salesForceSelected?._id,
        username: this.salesForceSelected?.username,
        email: this.salesForceSelected?.email,
      },
      business_partner_id: this.salesForceSelected?.businessPartnerId,
      type: this.salesForceSelected?.type,
    }

    const orderPaymentCondition = {
      _id: this.paymentConditionSelected?._id,
      externalKeys: this.paymentConditionSelected?.externalKeys,
      daysToPay: this.paymentConditionSelected?.daysToPay,
      id: this.paymentConditionSelected?.id,
      name: this.paymentConditionSelected?.name,
      statusId: this.paymentConditionSelected?.statusId,
      type: this.paymentConditionSelected?.type,
    }

    let order:OrderAttributesExt = {
      //code: null, //TODO Por ahora quemar codigo para generacion, pero el backend tiene que recibir
      code: null,
      mobileCode: null,
      serial: null,
      reference: this.referenceControl.value,
      //externalKeys: null,
      application: this.applicationSelected,
      subApplication: this.subApplicationSelected,
      type: this.documentClassSelected?.documentType,
      class: orderClass,
      expeditionCondition: orderExpeditionCondition,
      sourceTransactions: [],
      company: orderCompany,
      distributionChain: orderDistributionChain,
      salesOffice: orderSalesOffice,
      routes: [],
      subRoute: null,
      deliverySubRoute: orderDeliverySubRoute && orderDeliverySubRoute._id ? orderDeliverySubRoute : null,
      warehouses: [orderWarehouse],
      user: orderUser && orderUser._id ? orderUser : null,
      shipTo: orderShipTo,
      soldTo: orderSoldTo,
      address: this.addressSelected,
      interlocutors: [],
      currency: orderCurrency,
      //reasonForRejection: null,
      creationDateTime: new Date(),
      loadDateTime: this.chargeDateControl.value,
      deliveryDateTimeSuggested: null,
      deliveryDateTime: this.getDateWithHour(this.deliveryDateControl.value, this.deliveryHourControl.value),  
      realDeliveryDateTime: null,
      note: this.comentariesControl.value,
      subTotalBeforeTaxes: 0,
      subTotal: 0,
      totalTaxes: 0,
      totalDiscounts: 0,
      totalSurcharges: 0,
      total: 0,
      //balance: null,
      isOrderTaxExempt: false, //TODO colocar en base a la variable de si tiene tiene impuesto
      detail: [],
      //dataERP: null,
      trip: null,
      //statusERP: null,
      //statusId: null,
      paymentCondition: orderPaymentCondition,
    }

    let orderSourceTransactions = null
    if(this.quoteLoaded && this.quoteSelected){
      orderSourceTransactions = [{
        type: this.quoteSelected?.type,
        class: this.quoteSelected?.class,
        code: this.quoteSelected?.code,
        serial: this.quoteSelected?.serial,
        position: null,
        externalKeys: {
          code: this.quoteSelected?.externalKeys?.code || null,
          position: this.quoteSelected?.externalKeys?.position || null,
        }
      }]
      order.sourceTransactions = orderSourceTransactions;
    }

    const itemsArray = Object.values(this.auxMaterialsToCart)
    const detailArray = this.isLostSaleAllowed ? itemsArray : itemsArray.filter(i => i.hasLostSale !== '1' && i.productQuantity > 0);

    detailArray.forEach((item:any, index) => {
      const detailUMB = {
        _id: item.productUMB?.unitOfMeasure?._id,
        code: item.productUMB?.unitOfMeasure?.code,
        name: item.productUMB?.unitOfMeasure?.name,
      }
      
      const detailUMP = {
        _id: item.productUMP?.unitOfMeasure?._id,
        code: item.productUMP?.unitOfMeasure?.code,
        name: item.productUMP?.unitOfMeasure?.name,
      }

      const UnitMeasurSold = item.alternalUnitOfMeasures.find(aum => aum.unitOfMeasure._id.toString() == item.productUnitMeasureId)
      const detailUMSold = {
        _id: UnitMeasurSold?.unitOfMeasure?._id,
        code: UnitMeasurSold?.unitOfMeasure?.code,
        name: UnitMeasurSold?.unitOfMeasure?.name,
      }

      const taxPercentage = item.tax?.percentage ?? 0;
      const warehouse = this.warehousesList.find(wh => wh._id.toString() == item.productWarehouseId) || null

      const material = {
        _id: item._id,
        externalKeys: item.externalKeys,
        code: item.code,
        materialGroups: item.materialGroups,
        name: item.name,
        UMPActive: item.UMPActive,
        batchControlActive: item.batchControlActive ? item.batchControlActive : false
      }

      let detailData = {
        baseOriginalQuantity: item.productQuantityUMB,
        baseConversionFactor: item.productUMB?.conversionFactor,
        baseQuantity: item.productQuantityUMB,
        pararellOriginalQuantity: item.productQuantityUMP,
        pararellConversionFactor: item.productUMP?.conversionFactor ? 1 / item.productUMP.conversionFactor : null,
        pararellQuantity: item.productQuantityUMP,
        soldOriginalQuantity: item.productQuantity,
        soldQuantity: item.productQuantity,
        originalUnitPrice: 0, //Calculo abajo
        unitPrice: 0, //Calculo abajo
        priceConditionClasses: item.productPrice ? item.productPrice.conditionClasses : [],
        hasMinimumAndMaximunPrices: false,
        minimumAndMaximunPrices: {
          minimumPrice: 0,
          maximumPrice: 0
        },
        hasScalePrices: false,
        scalePrices: {
          quantityFrom: 0,
          quantityTo: 0,
          minimumAndMaximunPrices: {
            minimumPrice: 0,
            maximumPrice: 0
          },
          price: 0
        },
        discounts: [],
        surcharges: [],
        taxes: [
          {
            code: item.tax?.percentage.toString(),
            name: item.tax?.percentage.toString(),
            taxBase: item.priceToShow,
            percentage: Number(item.tax.percentage), //Number
            amount: this.calculateTax(item.priceToShow, item.tax.percentage)
          }
        ],
        batches: [],
        subTotal: 0, //Calculo abajo
        subTotalBeforeTaxes: 0, //Calculo abajo //suma de detalle sin impuesto
        totalTaxes: 0, //Calculo abajo
        totalDiscounts: 0,
        totalSurcharges: 0, //monto adicional
        note: item.productComment,
        position: index+1,
        sourceTransaction: null,
        warehouse: warehouse,
        material: material,
        baseUnitOfMeasure: detailUMB,
        pararellUnitOfMeasure: item.productUMP ? detailUMP : null,
        soldUnitOfMeasure: detailUMSold,
        total: 0,  //Calculo abajo
        //quantity consultar
        soldQuantitySuggested: 0,
        stockAtCreation: item?.productStock?.availableStock ?? 0,
      }

      if(this.quoteLoaded && this.quoteSelected){
        detailData.sourceTransaction = {
          type: this.quoteSelected?.type,
          class: this.quoteSelected?.class,
          code: this.quoteSelected?.code,
          serial: this.quoteSelected?.serial,
          position: item.position,
          externalKeys: {
            code: this.quoteSelected?.externalKeys?.code || null,
            position: this.quoteSelected?.detail.find(d => 
              d.material._id.toString() == item._id.toString()
            )?.externalKeys?.position ?? null,
          }
        }
      }

      //CALCULO PRECIOS DETALLE
      detailData.originalUnitPrice = this.roundToX((item.priceToShow - this.calculateTax(item.priceToShow, taxPercentage)),2);
      detailData.unitPrice = this.roundToX((item.priceToShow - this.calculateTax(item.priceToShow, taxPercentage)),2);
      detailData.subTotal = this.roundToX(detailData.unitPrice * item.productQuantity, 2);
      detailData.subTotalBeforeTaxes = this.roundToX(detailData.subTotal - detailData.totalDiscounts + detailData.totalSurcharges,2);
      detailData.totalTaxes = this.calculateTax(item.priceToShow, taxPercentage) * item.productQuantity;
      detailData.total = detailData.subTotalBeforeTaxes + detailData.totalTaxes

      //CALCULO PRECIOS CABECERA
      order.subTotal = this.roundToX(order.subTotal + detailData.subTotal, 2);
      order.totalDiscounts = order.totalDiscounts + detailData.totalDiscounts;
      order.totalSurcharges = order.totalSurcharges + detailData.totalSurcharges;
      order.subTotalBeforeTaxes = this.roundToX(order.subTotalBeforeTaxes + detailData.subTotalBeforeTaxes, 2);
      order.totalTaxes = order.totalTaxes + detailData.totalTaxes;

      if(this.isLostSaleAllowed){ //Se actualiza aca ya que se requiere que se envie el subtotal al ERP y no se quiere afectar a la sumatoria de los subtotales
        //todo realizar todo el calculo dejar solo soldQuantity en 0
        detailData.soldQuantitySuggested = item.soldQuantitySuggested == 0 ? detailData.soldQuantity : item.soldQuantitySuggested;
        detailData.totalTaxes = this.calculateTax(item.priceToShow, taxPercentage) * detailData.soldQuantitySuggested;
        detailData.subTotal = this.roundToX(detailData.unitPrice * detailData.soldQuantitySuggested, 2);
        detailData.subTotalBeforeTaxes = this.roundToX(detailData.subTotal - detailData.totalDiscounts + detailData.totalSurcharges,2);
      }

      order.detail.push(detailData);
    })
    
    order.total = order.subTotalBeforeTaxes + order.totalTaxes;

    let orderFormat: ShipmentRequestInterface = {
      confirmed: flag,
      orders: [order]
    }

    this.ordersCreationService.generateOrder(orderFormat).subscribe({
      next: (res: any) => {
        if(res && res.invalid && res.invalid.length > 0 ){
          this.orderErrorList = res.invalid
          this.openErrorStockDialog();
          return;
        }
        if(flag){
          this.openOrderDialog()

          if(this.type == 'divide'){ //Accion: Borrar lineas si es division de pedido
            const dataToUpdate: IUpdateOrder = {};
            dataToUpdate.detail = []

            if (this.positions && this.positions.trim() !== "") { //Si hay posiciones entrara al if para eliminarlas si hay division de pedido
              // Convertir posiciones de pedido/cotizacion vinculada en un array de números
              let positionsArray = this.positions.split(',').map(num => Number(num.trim()));
              positionsArray.forEach(p => {
                dataToUpdate.detail.push({
                  position: p,
                  reasonForRejection: `Eliminado por division de pedido (${this.quoteSelected.serial}).`,
                  statusId: StatusEnum.INACTIVE,
                })
              })

              if(positionsArray.length > 0){
                this.updateOrderService
                  .updateOrder(String(this.quoteLoaded), dataToUpdate)
                  .subscribe({
                    next: (res) => {
                      this.snackBar.open(`Lineas de pedido ${this.quoteSelected.serial} eliminadas con exito`,"Cerrar",{ duration: 5000});
                    },
                    error: (err) => {
                      this.snackBar.open(`Error al eliminar lineas de pedido ${this.quoteSelected.serial}.`,"Cerrar",{ duration: 5000});
                    },
                  });
              }
            }
          }

          if(this.type == 'generate'){
            const dataToUpdate: IUpdateOrder = {};
            dataToUpdate.nextTransactions = []
            if(res && res.valid && res.valid.length > 0){
              res.valid.forEach(o => {
                dataToUpdate.nextTransactions.push({
                  type: res?.type,
                  class: res?.class,
                  code: res?.code,
                  serial: res?.serial,
                  position: null,
                  externalKeys: {
                    code: res?.externalKeys.code ?? null,
                    position: res?.externalKeys.position ?? null,
                  }
                })
              })
            }
          }
        }else{
          this.isSuggedtedDate(res)
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al generar orden.","Cerrar",{ duration: 5000});
      },
    });
  }

  isSuggedtedDate(resValidOrder: any): void{
    this.systemSuggestedDate = resValidOrder?.valid?.[0]?.deliveryDateTimeSuggested ?? null;
    
    if (this.systemSuggestedDate) {
      this.openSuggestedDateDialog();
    }
  }

  openSuggestedDateDialog(): void {
    this.dialog
      .open(this.orderSuggestedDateDialog, { data: null, panelClass: "form-modal", disableClose: true})
      .afterClosed()
      .subscribe((result) => result && this.changeSuggestedDate());
  }

  changeSuggestedDate(){
    this.deliveryDateControl.setValue(this.systemSuggestedDate);
  }

  getDateWithHour(date, time){
    const [hours, minutes] = time.split(/[: ]/).slice(0, 2).map(Number);
    const isPM = time.includes('PM');

    const newDate = new Date(this.deliveryDateControl.value);
    newDate.setHours(isPM && hours < 12 ? hours + 12 : !isPM && hours === 12 ? 0 : hours);
    newDate.setMinutes(minutes);
    return newDate;
  }

  getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return `${hours}:${formattedMinutes} ${ampm}`;
  }

  openOrderDialog(): void {
    this.dialog
      .open(this.orderFinalizedDialog, { data: null, panelClass: "form-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.newOrder());
  }

  newOrder(): void {
    this.formData.reset();  
    this.formData.patchValue({
      documentDateControl: new Date(),
      deliveryDateControl: new Date(),
      chargeDateControl: new Date(),
      deliveryHourControl: this.getCurrentTime(),
    });

    this.selectedCurrency = null
    this.paymentConditionSelected = null
    this.soldToSelected = null
    this.salesOfficeSelected = null
    this.salesOfficesList = []
    this.shipToList = []

    if(this.salesOfficesList.length == 1){
      this.salesOfficeControl.setValue(this.salesOfficesList[0]._id.toString());
      this.onSalesOfficeChange();
    }

    if(this.documentClassesList.length == 1){
      this.documentClassControl.setValue(this.documentClassesList[0]._id.toString());
      this.onDocumentClassChange();
    }

    if(this.shipToList.length == 1){
      this.shipToControl.setValue(this.shipToList[0]._id.toString())
      this.onShipToChange();
    }

    this.dataSourceOrder = []
    //this.snackBar.open('', 'Cerrar', { duration: 3000 });
    this.tabGroup.selectedIndex = 0;

    if(this.quoteLoaded && this.quoteSelected){
      this.loadQuoteData();
      this.fetchSalesOffice();
    }
  }

  redirectList(){
    this.router.navigate(['master', 'sales', 'orders-list']);
  }

  removeLeadingZeros(value: string){
    return value.replace(/^0+/, "");
  }

  onAddressChange():void {
    this.addressSelected = this.addressesList.find(ad => ad._id.toString() == this.addressControl.value)
  }

  setControlValidators(control: AbstractControl, isRequired: boolean){
    if (isRequired) {
      control.setValidators(Validators.required);
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity();
  }

  roundToX(value: number, decimals: number){
    return parseFloat(value.toFixed(decimals))
  }

  calculateTax(price:number, taxPercentage: number){
    return this.roundToX(getISVofTotal(price, taxPercentage), 2);
  }

  calculatePriceWithOutTax(price: number, taxPercentage: number, isTaxIncluded:boolean){
    const taxAmount = this.calculateTax(price, taxPercentage)
    return isTaxIncluded ? price - taxAmount : price;
  }

  openConfirmationDialog(): void{
    this.dialog
      .open(this.orderConfirmationDialog, { data: null, panelClass: "form-modal", disableClose: true})
      .afterClosed()
      .subscribe((result) => result && this.generateOrder(true))
  }

  openOrderStockDialog(): void{
    this.dialog
      .open(this.orderStockDialog, { data: null, width: "90%", disableClose: true })
      .afterClosed()
      .subscribe((result) => result)
  }

  openErrorStockDialog(): void {
    this.dialog
      .open(this.orderErrorDialog, { data: null, width: "90%", disableClose: true })
      .afterClosed()
      .subscribe((result) => result)
  }
  
  togglePopover(event: MouseEvent) {
    event.stopPropagation(); // Evitar que el evento cierre el popover inmediatamente
    this.isPopoverVisible = !this.isPopoverVisible;
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement) {
    // Si el popover está visible, verificar si el clic ocurrió fuera
    if (this.isPopoverVisible) {
      const clickedInside = this.popoverElement?.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.isPopoverVisible = false;
      }
    }
  }

  fetchCategories(): void{
    this.ordersCreationService.fetchCategories(
      environment.companyId, 
      this.salesOfficeSelected ? this.salesOfficeSelected.divisions ? this.salesOfficeSelected.divisions.map(div => div.id) : [] : [],
      this.filter.itemGroup.code,
    ).subscribe({
      next: (res) => {
        if(res.status=='success'){
          this.materialGroupList = res.data;
          this.materialGroupFilterList = this.materialGroupList.slice();

          this.listCategories = res.data.slice()
          this.getTree(this.categoryPrincipal, '0')
          this.categoryNode.push(this.categoryPrincipal)
          //this.treeControl1.dataNodes = this.categoryNode
          this.dataSourceN1.data = this.categoryNode
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener categorias.","Cerrar",{ duration: 5000});
      },
    });
  }

  getTree(data: CategoryNode, fatherCode) {
    data.children = this.listCategories.filter(res => res.fatherCode == fatherCode)
    for (let item of data.children) {
      if (item.hasSubcategories) {
        item.children = []
        this.getTree(item, item.code)
      }
    }
  }

  //hasChild = (_: number, node: CategoryNode) => !!node?.children && node?.children.length > 0;
  hasChild = (_: number, node: FlatNode) => node.expandable;

  public filterTree(filterText: string): void {
    let filteredTreeData = [];
    let adicional = []

    if (filterText) {
      filteredTreeData = this.listCategories.filter(d => d.name.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1);
      for (let item of filteredTreeData) {
        let fatherCode = item.fatherCode
        while (fatherCode != '0') {
          let padre = this.listCategories.find(res => res.code == fatherCode)
          fatherCode = padre.fatherCode
          if (!(adicional.find(res => res.code == item.code))) {
            let aux2 = padre
            delete aux2.children
            adicional.push(aux2)
          }
        }
      }

      for (let item of adicional) {
        filteredTreeData.push(item)
      }

      var unique = filteredTreeData.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      })
      filteredTreeData = unique
    } else {
      filteredTreeData = this.listCategories;
    }

    let categoryPrincipalF: CategoryNode = {
      name: 'Todos',
      code: '0',
      fatherCode: '0',
      hasSubcategories: true,
      level: 0,
      expandable: true,
      children: [],
    }

    this.listFilterCategories = filteredTreeData
    this.getTreeFilter(categoryPrincipalF, '0')
    this.categoryNodeFilter = []
    this.categoryNodeFilter.push(categoryPrincipalF)
    //this.treeControl1.dataNodes = this.categoryNodeFilter
    this.dataSourceN1.data = this.categoryNodeFilter
    if (filterText) {
      this.treeControl1.expandAll();
    } else {
      this.treeControl1.collapseAll();
    }
  }

  getTreeFilter(data: CategoryNode, fatherCode) {
    data.children = this.listFilterCategories.filter(res => res.fatherCode == fatherCode)
    for (let item of data.children) {
      if (item.hasSubcategories) {
        item.children = []
        this.getTreeFilter(item, item.code)
      }
    }
  }

  onRadioGroupClick(event){
    this.findAllWithCount();
  }

  getFormattedStock(element){
    const stock = element?.productStock?.availableStock ?? 0;
    const decimals = element?.productAlternalUnitOfMeasuresSelected?.unitOfMeasure.hasacceptedDecimals ?? 0;
    return decimals ? this.roundToX(stock, 2) : Math.floor(stock).toString();
  }

  setMaterialsToCart(element){
    if (element.productQuantity === 0 || element.productQuantity === null) {
      //delete this.auxMaterialsToCart[element._id.toString()];
    } else {
      this.auxMaterialsToCart[element._id.toString()] = element;
    }
  }

  onShowCartChange(event: boolean): void{
    this.filter.showCart = event
    this.findAllWithCount();
  }

  onWithStockChange(event: boolean): void{
    this.filter.withStock = event;
    this.findAllWithCount();
  }

  clearSelection(): void {
    this.quoteLoaded = null; // Limpia el modelo.
  }
  

  getOrderOrQuoteById(){
    this.ordersCreationService.getOrderById(this.quoteLoaded).subscribe({
      next: (res) => {
        if(res.status=='success'){
          this.quoteSelected = res.data
          this.quoteList = [this.quoteSelected]
          this.loadQuoteData();
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener orden o cuota.","Cerrar",{ duration: 5000});
      },
    });
  }

  loadQuoteData(){
    if(this.quoteSelected){
      //Setear campos cabecera
      this.salesOfficeControl.setValue(this.quoteSelected?.salesOffice?._id.toString());
      this.shipToControl.setValue(this.quoteSelected?.shipTo?.id.toString())
      this.expeditionConditionControl.setValue(this.quoteSelected?.expeditionCondition?._id?.toString());

      this.addressControl.setValue(this.quoteSelected?.address?._id.toString())
      this.warehouseControl.setValue(this.quoteSelected?.warehouses[0]?._id.toString())
      this.paymentConditionControl.setValue(this.quoteSelected?.paymentCondition?._id.toString())
      this.salesForceControl.setValue(this.quoteSelected?.user?._id.toString())
      
      this.chargeDateControl.setValue(new Date(this.quoteSelected?.loadDateTime))

      let auxDeliveryDate = new Date(this.quoteSelected?.deliveryDateTime)
      if(this.quoteSelected?.deliveryDateTime){
        this.deliveryDateControl.setValue(auxDeliveryDate)
        this.deliveryHourControl.setValue(auxDeliveryDate.getHours()+':'+auxDeliveryDate.getMinutes())
      }
      this.referenceControl.setValue(this.quoteSelected?.reference)
      this.comentariesControl.setValue(this.quoteSelected?.note)

      if(this.type == 'copy' || this.type == 'divide'){
        this.documentClassControl.setValue(this.quoteSelected?.class?._id.toString())
        this.onDocumentClassChange();
      }
    }
  }

  ngOnDestroy(){
    this.subs.forEach(element => {
      element.unsubscribe()
    });
  }
}
